import React from 'react';
import { browserHistory } from 'react-router'
import styles from './NavBarMenu.css';
import { UserLogout, LoggedUserAdmin } from '../login/Login';


export default class NavBarMenu extends React.Component {

  Logout = () => {
    UserLogout();
    this.props.setUser(0,'');
    browserHistory.push('/')
  }

  render() {
    return null;

    return (
      <nav className="main-menu">
          <ul>
            <li>
              <a href="#">
                <i className="fa fa-home"></i>
                <span className="nav-text">
                    Úvod
                </span>
              </a>
            </li>
            {LoggedUserAdmin() ?
              <li className="has-subnav">
                <a href="#users-list">
                  <i className="fa fa-users"></i>
                  <span className="nav-text">
                      Správa uživatelů
                  </span>
                </a>
              </li>
              : null
            }
            {LoggedUserAdmin() ?
              <li className="has-subnav">
                <a href="#event-list">
                  <i className="fa fa-calendar-alt"></i>
                  <span className="nav-text">
                      Správa lekcí
                  </span>
                </a>
              </li>
              : null
            }
            <li className="has-subnav">
              <a href="#user-detail">
                <i className="fa fa-user"></i>
                <span className="nav-text">
                    Detail uživatele
                </span>
              </a>
            </li>
          </ul>

          <ul className="logout">
            <li>
               <a href="#logout" onClick={this.Logout}>
                  <i className="fa fa-power-off"></i>
                  <span className="nav-text">
                    Logout
                  </span>
                </a>
            </li>
          </ul>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// src/components/pages/NavBarMenu.js